import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

// https://app.avantprotocol.com/api/apy/savusd
// https://app.avantprotocol.com/api/apy/saveth
// https://app.avantprotocol.com/api/apy/savbtc
// output format: {"apy":"7.03","lastUpdated":"2026-04-14"}

const AVANT_BASE = 'https://app.avantprotocol.com/api/apy'

const sAVUSD = 'Staked avUSD::savUSD'
const sAVETH = 'Staked avETH::savETH'
const sAVBTC = 'Staked avBTC::savBTC'

const fetchAvantApr = async (slug: string): Promise<number> => {
  const res = await fetch(`${AVANT_BASE}/${slug}`).then((r) => r.json())
  const apy = Number(res?.apy ?? 0)
  return apyToAprPercent(apy)
}

export const savusdFetcher: YieldFetcher = {
  label: 'SAVUSD',
  fetch: async () => ({ [sAVUSD]: await fetchAvantApr('savusd') }),
}

export const savethFetcher: YieldFetcher = {
  label: 'SAVETH',
  fetch: async () => ({ [sAVETH]: await fetchAvantApr('saveth') }),
}

export const savbtcFetcher: YieldFetcher = {
  label: 'SAVBTC',
  fetch: async () => ({ [sAVBTC]: await fetchAvantApr('savbtc') }),
}
